import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "save-module-section",
  "data-preset-category": "saveModules",
  "aria-label": "存档模块"
}
const _hoisted_2 = { class: "source-toolbar" }
const _hoisted_3 = { role: "status" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_8 = {
  key: 1,
  class: "error",
  role: "alert"
}
const _hoisted_9 = {
  key: 2,
  class: "source-select"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "hint" }
const _hoisted_12 = { class: "join-hint" }
const _hoisted_13 = { class: "binary-workbench" }
const _hoisted_14 = {
  class: "integer-list",
  "aria-label": "100 个存档整数"
}
const _hoisted_15 = { class: "nonzero-toggle" }
const _hoisted_16 = ["aria-label", "aria-pressed", "data-integer-index", "onClick"]
const _hoisted_17 = { class: "integer-index" }
const _hoisted_18 = { class: "integer-decimal" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "list-footnote" }
const _hoisted_21 = { class: "integer-workbench" }
const _hoisted_22 = {
  class: "binary-card",
  "aria-labelledby": "binary-integer-title"
}
const _hoisted_23 = { class: "decimal-input" }
const _hoisted_24 = ["value"]
const _hoisted_25 = ["data-binary-integer"]
const _hoisted_26 = { class: "binary-row-label" }
const _hoisted_27 = ["aria-label", "onClick"]
const _hoisted_28 = ["aria-label"]
const _hoisted_29 = ["aria-label", "aria-pressed", "title", "data-bit", "data-selected", "disabled", "onClick", "onPointerdown", "onPointerenter"]
const _hoisted_30 = {
  class: "bit-index",
  "aria-hidden": "true"
}
const _hoisted_31 = { class: "hint selection-hint" }
const _hoisted_32 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_33 = {
  class: "segment-editor",
  "aria-labelledby": "segment-editor-title"
}
const _hoisted_34 = { id: "segment-editor-title" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "span-inputs" }
const _hoisted_37 = ["value", "max", "disabled"]
const _hoisted_38 = ["value", "max", "disabled"]
const _hoisted_39 = { class: "span-location" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "hint" }
const _hoisted_43 = { class: "selected-span" }
const _hoisted_44 = {
  role: "status",
  "aria-label": "选中位段二进制"
}
const _hoisted_45 = { class: "selected-value" }
const _hoisted_46 = { class: "description-input" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "range-settings" }
const _hoisted_49 = ["title"]
const _hoisted_50 = { class: "range-inputs" }
const _hoisted_51 = ["value", "inputmode", "disabled"]
const _hoisted_52 = ["value", "inputmode", "disabled"]
const _hoisted_53 = {
  key: 0,
  class: "error field-errors",
  role: "alert"
}
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  class: "saved-spans",
  "aria-labelledby": "saved-spans-title"
}
const _hoisted_56 = { class: "hint" }
const _hoisted_57 = {
  key: 0,
  class: "hint"
}
const _hoisted_58 = ["data-field-id"]
const _hoisted_59 = ["aria-label", "onClick"]
const _hoisted_60 = { class: "hint" }
const _hoisted_61 = { class: "span-value" }
const _hoisted_62 = ["disabled", "aria-label", "onClick"]
const _hoisted_63 = {
  key: 1,
  class: "error"
}
const _hoisted_64 = {
  key: 0,
  class: "saved-spans",
  "aria-label": "范围无效的位段"
}
const _hoisted_65 = ["data-field-id"]
const _hoisted_66 = { class: "error" }
const _hoisted_67 = {
  key: 0,
  class: "hint"
}
const _hoisted_68 = ["disabled", "aria-label", "onClick"]
const _hoisted_69 = ["disabled", "aria-label", "onClick"]

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import StudioSelectField from "../StudioSelectField.vue";
import { useSaveModules } from "./useSaveModules";
import {
  SAVE_INTEGER_COUNT, SAVE_BIT_COUNT, createSaveModule, createSaveModuleField,
  formatSaveIntegerBinary, getSaveFieldBinary, getSaveFieldBitLength, getSaveFieldRange,
  readSaveFieldValue, validateSaveModules, type SaveModule, type SaveModuleField,
} from "./saveModules";
import { importSaveModuleGia, type SaveModuleGiaCandidate } from "./saveModuleGia";


export default /*@__PURE__*/_defineComponent({
  __name: 'SaveModuleSection',
  setup(__props, { expose: __expose }) {

const { customPresets, availablePresets, systemPresets, ready, error, status, retry, flush } = useSaveModules();
const saveStatus = computed(() => status.value.includes("系统") ? "位段说明自动保存到当前工作区" : status.value);
const fileInput = ref<HTMLInputElement>();
const importing = ref(false), importError = ref(""), previewError = ref(""), fileName = ref("");
const candidates = ref<SaveModuleGiaCandidate[]>([]), selectedCandidate = ref("");
const sourceCandidate = computed(() => candidates.value.find(item => item.id === selectedCandidate.value));
const previewValues = ref(Array<number>(SAVE_INTEGER_COUNT).fill(0));
const previewIndex = ref(0), nonzeroOnly = ref(false);
const integerRowsElement = ref<HTMLElement>(), binaryRowsElement = ref<HTMLElement>();
const previewModified = computed(() => previewValues.value.some((value, index) => value !== (sourceCandidate.value?.values[index] ?? 0)));
const nonzeroCount = computed(() => previewValues.value.filter(value => value !== 0).length);
const binaryRows = computed(() => previewValues.value.map((value, index) => ({ value, index, binary: formatSaveIntegerBinary(value) })));
const rows = computed(() => binaryRows.value.filter(row => !nonzeroOnly.value || row.value !== 0 || row.index === previewIndex.value));
const bitColumns = Array.from({ length: 32 }, (_, position) => position);
const systemIds = computed(() => new Set(systemPresets.value.map(module => module.id)));
const entries = computed(() => availablePresets.value.flatMap(module => module.fields.map(field => ({
  key: `${module.id}/${field.id}`, module, field, editable: !systemIds.value.has(module.id),
}))));
function validLocation(field: SaveModuleField) { try { getSaveFieldBitLength(field); return true; } catch { return false; } }
function endBit(field: SaveModuleField) { return field.startBit + field.length - 1; }
function coversInteger(field: SaveModuleField, index: number) { return validLocation(field) && field.startBit < (index + 1) * 32 && endBit(field) >= index * 32; }
const orphanEntries = computed(() => entries.value.filter(entry => !validLocation(entry.field)));
const savedIssues = computed(() => validateSaveModules(availablePresets.value));
const editingKey = ref("");
const editingEntry = computed(() => entries.value.find(entry => entry.key === editingKey.value));
const draft = ref<SaveModuleField>(createSaveModuleField());
const draftTouched = ref(false), selectionAnchor = ref<number | null>(null);
let dragAnchor: number | null = null, dragMoved = false, suppressClick = false;
const draftRange = computed(() => { try { return getSaveFieldRange(draft.value); } catch { return null; } });
const draftBinary = computed(() => { try { return getSaveFieldBinary(previewValues.value, draft.value); } catch { return ""; } });
const draftValue = computed(() => { try { return readSaveFieldValue(previewValues.value, draft.value); } catch { return null; } });
const draftIssues = computed(() => {
  const moduleId = editingEntry.value?.module.id ?? `draft:${draft.value.id}`;
  const modules = availablePresets.value.map(module => ({ ...module, fields: module.fields.filter(field => `${module.id}/${field.id}` !== editingKey.value) }));
  let target = modules.find(module => module.id === moduleId);
  if (!target) { target = { id: moduleId, name: "", fields: [] }; modules.push(target); }
  target.fields.push(draft.value);
  return validateSaveModules(modules).filter(issue => issue.moduleId === moduleId && issue.fieldId === draft.value.id);
});
const canSave = computed(() => ready.value && draft.value.name.trim() && !draftIssues.value.length && (!editingEntry.value || editingEntry.value.editable));
const causeMessage = (cause: unknown) => cause instanceof Error ? cause.message : "无法读取存档，请检查文件内容。";
const integerText = (value: string) => /^-?\d+$/.test(value);
function compactNumber(value: string) { return value.length > 35 ? `${value.slice(0, 18)}…${value.slice(-10)}` : value; }
function firstFreeBit(start: number) {
  for (let offset = 0; offset < SAVE_BIT_COUNT; offset++) {
    const bit = (start + offset) % SAVE_BIT_COUNT;
    if (!entries.value.some(entry => validLocation(entry.field) && bit >= entry.field.startBit && bit <= endBit(entry.field))) return bit;
  }
  return start;
}
function newSegment() {
  editingKey.value = "";
  draft.value = createSaveModuleField();
  draft.value.startBit = firstFreeBit(previewIndex.value * 32);
  selectionAnchor.value = null; draftTouched.value = false; previewError.value = "";
}
function chooseInteger(index: number) {
  previewIndex.value = index;
  // Browsing another integer never changes the pending global span or its anchor.
  void nextTick(() => {
    const list = integerRowsElement.value;
    const row = list?.querySelector<HTMLElement>(`[data-integer-index="${index}"]`);
    if (list && row && Number.isFinite(row.offsetTop)) list.scrollTop = Math.max(0, row.offsetTop - (list.clientHeight - row.offsetHeight) / 2);
    const canvas = binaryRowsElement.value;
    const binaryRow = canvas?.querySelector<HTMLElement>(`[data-binary-integer="${index}"]`);
    if (canvas && binaryRow && Number.isFinite(binaryRow.offsetTop)) canvas.scrollTop = binaryRow.offsetTop;
  });
}
watch(ready, value => { if (value && !editingKey.value) newSegment(); });
function selectEntry(key: string) {
  const entry = entries.value.find(item => item.key === key);
  if (!entry) return;
  editingKey.value = key; draft.value = { ...entry.field }; selectionAnchor.value = null;
  if (validLocation(entry.field)) chooseInteger(Math.floor(entry.field.startBit / 32));
}
// Other rows can change without replacing the saved contents of the selected row.
watch(() => editingEntry.value ? JSON.stringify(editingEntry.value.field) : "", snapshot => {
  if (snapshot) draft.value = JSON.parse(snapshot) as SaveModuleField;
  else if (editingKey.value) newSegment();
}, { flush: "sync" });
function repairSegment(key: string) {
  selectEntry(key);
  draft.value.startBit = previewIndex.value * 32;
  draft.value.length = Math.min(Number.isInteger(draft.value.length) && draft.value.length > 0 ? draft.value.length : 1, SAVE_BIT_COUNT - draft.value.startBit);
  delete draft.value.legacyLocation;
  draftTouched.value = true;
}
function setSpan(start: number, length: number) {
  const oldRange = draftRange.value;
  draft.value.startBit = start; draft.value.length = length; draftTouched.value = true;
  const range = draftRange.value;
  if (range !== null) {
    delete draft.value.legacyLocation;
    for (const key of ["min", "max"] as const) {
      const value = draft.value[key];
      if (value === oldRange?.[key] || (integerText(value) && (BigInt(value) < BigInt(range.min) || BigInt(value) > BigInt(range.max)))) draft.value[key] = range[key];
    }
    if (integerText(draft.value.min) && integerText(draft.value.max) && BigInt(draft.value.min) > BigInt(draft.value.max)) draft.value.min = range.min;
  }
}
function chooseBit(bit: number, event: MouseEvent) {
  if (suppressClick && event.detail !== 0) { suppressClick = false; return; }
  suppressClick = false;
  if (editingEntry.value && !editingEntry.value.editable) return;
  if (selectionAnchor.value === null) { selectionAnchor.value = bit; setSpan(bit, 1); }
  else { setSpan(Math.min(selectionAnchor.value, bit), Math.abs(selectionAnchor.value - bit) + 1); selectionAnchor.value = null; }
}
function startDrag(bit: number, event: PointerEvent) {
  if (event.button !== 0 || (editingEntry.value && !editingEntry.value.editable)) return;
  suppressClick = false; dragAnchor = bit; dragMoved = false;
}
function extendDrag(bit: number) {
  if (dragAnchor === null || dragAnchor === bit) return;
  dragMoved = true; selectionAnchor.value = null;
  setSpan(Math.min(dragAnchor, bit), Math.abs(dragAnchor - bit) + 1);
}
function finishDrag() { if (dragAnchor !== null) { suppressClick = dragMoved; dragAnchor = null; dragMoved = false; } }
function cancelDrag() { dragAnchor = null; dragMoved = false; suppressClick = false; }
onMounted(() => { if (typeof window !== "undefined") { window.addEventListener("pointerup", finishDrag); window.addEventListener("pointercancel", cancelDrag); window.addEventListener("blur", cancelDrag); } });
onBeforeUnmount(() => { if (typeof window !== "undefined") { window.removeEventListener("pointerup", finishDrag); window.removeEventListener("pointercancel", cancelDrag); window.removeEventListener("blur", cancelDrag); } });
function selectedBit(bit: number) { return bit >= draft.value.startBit && bit <= endBit(draft.value); }
function definedBit(bit: number) { return entries.value.some(entry => validLocation(entry.field) && bit >= entry.field.startBit && bit <= endBit(entry.field)); }
function bitTitle(bit: number) { return [`全局位 ${bit} · 整数 [${Math.floor(bit / 32)}] 的 bit ${bit % 32}（bit 0 为最低位，bit 31 为符号位）`, ...entries.value.filter(entry => validLocation(entry.field) && bit >= entry.field.startBit && bit <= endBit(entry.field)).map(entry => entry.field.name)].join(" · "); }
function integerInput(event: Event) { const text = (event.target as HTMLInputElement).value; return text.trim() && Number.isSafeInteger(Number(text)) ? Number(text) : null; }
function updateDecimal(event: Event, commit = false) {
  const value = integerInput(event);
  if (value !== null && value >= -2147483648 && value <= 2147483647) { previewValues.value[previewIndex.value] = value; previewError.value = ""; }
  else if (commit) { previewError.value = "请输入 −2147483648 ～ 2147483647 范围内的十进制整数。"; (event.target as HTMLInputElement).value = String(previewValues.value[previewIndex.value]); }
}
function updatePosition(key: "startBit" | "length", event: Event, commit = false) {
  const value = integerInput(event);
  if (value !== null) { setSpan(key === "startBit" ? value : draft.value.startBit, key === "length" ? value : draft.value.length); selectionAnchor.value = null; }
  else if (commit) (event.target as HTMLInputElement).value = String(draft.value[key]);
}
function updateRange(key: "min" | "max", event: Event, commit = false) {
  const value = (event.target as HTMLInputElement).value.trim();
  if (integerText(value)) { draft.value[key] = value; draftTouched.value = true; }
  else if (commit) (event.target as HTMLInputElement).value = draft.value[key];
}
function saveSegment() {
  if (!canSave.value) return;
  let module: SaveModule;
  if (editingEntry.value) { module = editingEntry.value.module; module.fields = module.fields.map(field => field.id === draft.value.id ? { ...draft.value } : field); }
  else {
    module = customPresets.value[0];
    if (!module) { module = createSaveModule(); customPresets.value = [module]; module = customPresets.value[0]; }
    module.fields.push({ ...draft.value });
  }
  editingKey.value = `${module.id}/${draft.value.id}`; selectionAnchor.value = null;
}
function deleteSegment(key: string) { const entry = entries.value.find(item => item.key === key); if (!entry?.editable) return; entry.module.fields = entry.module.fields.filter(field => field.id !== entry.field.id); if (editingKey.value === key) newSegment(); }
function entryBinary(field: SaveModuleField) { try { return getSaveFieldBinary(previewValues.value, field); } catch { return "位区间无效"; } }
function entryValue(field: SaveModuleField) { try { return readSaveFieldValue(previewValues.value, field); } catch { return null; } }
function entryLocation(field: SaveModuleField) {
  if (!validLocation(field)) return "范围无效";
  return `整数 [${Math.floor(field.startBit / 32)}] bit ${field.startBit % 32} → 整数 [${Math.floor(endBit(field) / 32)}] bit ${endBit(field) % 32}`;
}
function entryIssues(module: SaveModule, field: SaveModuleField) { return savedIssues.value.filter(issue => issue.moduleId === module.id && issue.fieldId === field.id); }
function outOfRange(field: SaveModuleField) { const value = entryValue(field); return value !== null && integerText(field.min) && integerText(field.max) && (BigInt(value) < BigInt(field.min) || BigInt(value) > BigInt(field.max)); }
function restorePreview() { previewValues.value = sourceCandidate.value ? [...sourceCandidate.value.values] : Array<number>(SAVE_INTEGER_COUNT).fill(0); previewError.value = ""; }
async function importFile(event: Event) {
  const input = event.target as HTMLInputElement, file = input.files?.[0];
  if (!file || importing.value) return;
  importing.value = true; importError.value = "";
  try {
    const result = await importSaveModuleGia(new Uint8Array(await file.arrayBuffer()));
    candidates.value = result.candidates; selectedCandidate.value = result.candidates[0].id; fileName.value = file.name;
    restorePreview(); chooseInteger(Math.max(0, previewValues.value.findIndex(value => value !== 0)));
    if (!draftTouched.value && !editingEntry.value) newSegment();
  } catch (cause) { importError.value = causeMessage(cause); }
  finally { importing.value = false; input.value = ""; }
}
__expose({ flush });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(saveStatus.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          ref_key: "fileInput",
          ref: fileInput,
          type: "file",
          accept: ".gia",
          "aria-label": "导入存档 GIA 文件",
          class: "file-input",
          onChange: importFile
        }, null, 544),
        _createElementVNode("button", {
          type: "button",
          class: "primary",
          disabled: importing.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (fileInput.value?.click()))
        }, _toDisplayString(importing.value ? '读取中…' : '导入存档 GIA'), 9, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          disabled: !previewModified.value,
          onClick: restorePreview
        }, _toDisplayString(sourceCandidate.value ? '恢复导入值' : '整数归零'), 9, _hoisted_6)
      ])
    ]),
    (_unref(error))
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
          _createTextVNode(_toDisplayString(_unref(error)) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(retry)().catch(() => undefined)))
          }, "重试")
        ]))
      : _createCommentVNode("", true),
    (importError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(importError.value) + " 原有整数值已保留。", 1))
      : _createCommentVNode("", true),
    (candidates.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("label", null, [
            _cache[16] || (_cache[16] = _createTextVNode("存档实例", -1)),
            _createVNode(StudioSelectField, {
              modelValue: selectedCandidate.value,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((selectedCandidate).value = $event)),
                restorePreview
              ],
              "aria-label": "选择存档实例"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(candidates.value, (candidate) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: candidate.id,
                    value: candidate.id
                  }, _toDisplayString(candidate.name), 9, _hoisted_10))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("span", _hoisted_11, _toDisplayString(fileName.value) + " · 100 个整数", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_12, "[0] → [1] → … → [99]，每项 32 位，最低位 bit 0 在左、符号位 bit 31 在右，共 " + _toDisplayString(_unref(SAVE_BIT_COUNT)) + " 位。全局编号 0–3199，位段可跨整数。", 1),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("aside", _hoisted_14, [
        _createElementVNode("header", null, [
          _createElementVNode("h3", null, [
            _cache[17] || (_cache[17] = _createTextVNode("整数列表 ", -1)),
            _createElementVNode("small", null, _toDisplayString(_unref(SAVE_INTEGER_COUNT)), 1)
          ]),
          _createElementVNode("label", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((nonzeroOnly).value = $event)),
              type: "checkbox",
              "aria-label": "只看非零整数"
            }, null, 512), [
              [_vModelCheckbox, nonzeroOnly.value]
            ]),
            _cache[18] || (_cache[18] = _createTextVNode("只看非零", -1))
          ])
        ]),
        _createElementVNode("div", {
          ref_key: "integerRowsElement",
          ref: integerRowsElement,
          class: "integer-rows"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
            return (_openBlock(), _createElementBlock("button", {
              key: row.index,
              type: "button",
              class: _normalizeClass(["integer-row", { active: previewIndex.value === row.index, nonzero: row.value !== 0 }]),
              "aria-label": `整数 ${row.index}，十进制 ${row.value}`,
              "aria-pressed": previewIndex.value === row.index,
              "data-integer-index": row.index,
              onClick: ($event: any) => (chooseInteger(row.index))
            }, [
              _createElementVNode("span", _hoisted_17, "[" + _toDisplayString(row.index) + "]", 1),
              _createElementVNode("span", _hoisted_18, [
                _createTextVNode(_toDisplayString(row.value), 1),
                (entries.value.some(entry => coversInteger(entry.field, row.index)))
                  ? (_openBlock(), _createElementBlock("small", _hoisted_19, "已定义位段"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("code", null, _toDisplayString(row.binary), 1)
            ], 10, _hoisted_16))
          }), 128))
        ], 512),
        _createElementVNode("p", _hoisted_20, "下标 0–99 · " + _toDisplayString(nonzeroCount.value) + " 项非零", 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("section", _hoisted_22, [
          _createElementVNode("header", null, [
            _cache[19] || (_cache[19] = _createElementVNode("h3", { id: "binary-integer-title" }, "拼接后的二进制串（低位在左）", -1)),
            _createElementVNode("label", _hoisted_23, [
              _createTextVNode("整数 [" + _toDisplayString(previewIndex.value) + "] 十进制", 1),
              _createElementVNode("input", {
                value: previewValues.value[previewIndex.value],
                type: "number",
                step: "1",
                min: "-2147483648",
                max: "2147483647",
                "aria-label": "十进制整数",
                onInput: _cache[4] || (_cache[4] = ($event: any) => (updateDecimal($event))),
                onChange: _cache[5] || (_cache[5] = ($event: any) => (updateDecimal($event, true)))
              }, null, 40, _hoisted_24)
            ])
          ]),
          _createElementVNode("div", {
            ref_key: "binaryRowsElement",
            ref: binaryRowsElement,
            class: "binary-rows",
            role: "region",
            "aria-label": "3200 位连续二进制串"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(binaryRows.value, (row) => {
              return (_openBlock(), _createElementBlock("div", {
                key: row.index,
                class: _normalizeClass(["binary-integer-row", { active: previewIndex.value === row.index }]),
                "data-binary-integer": row.index
              }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": `查看整数 ${row.index}`,
                    onClick: ($event: any) => (chooseInteger(row.index))
                  }, "整数 [" + _toDisplayString(row.index) + "] = " + _toDisplayString(row.value), 9, _hoisted_27),
                  _createElementVNode("span", null, "全局位 " + _toDisplayString(row.index * 32) + "–" + _toDisplayString(row.index * 32 + 31), 1)
                ]),
                _createElementVNode("div", {
                  class: "bit-string",
                  "aria-label": `整数 ${row.index} 的 32 位二进制`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bitColumns), (position) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: position,
                      type: "button",
                      class: _normalizeClass(["bit", { selected: selectedBit(row.index * 32 + position), defined: definedBit(row.index * 32 + position), 'byte-end': position % 8 === 7 }]),
                      "aria-label": `位 ${row.index * 32 + position}`,
                      "aria-pressed": selectedBit(row.index * 32 + position),
                      title: bitTitle(row.index * 32 + position),
                      "data-bit": row.index * 32 + position,
                      "data-selected": selectedBit(row.index * 32 + position),
                      disabled: !_unref(ready) || (!!editingEntry.value && !editingEntry.value.editable),
                      onClick: ($event: any) => (chooseBit(row.index * 32 + position, $event)),
                      onPointerdown: ($event: any) => (startDrag(row.index * 32 + position, $event)),
                      onPointerenter: ($event: any) => (extendDrag(row.index * 32 + position))
                    }, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(row.index * 32 + position), 1),
                      _createElementVNode("span", null, _toDisplayString(row.binary[position]), 1)
                    ], 42, _hoisted_29))
                  }), 128))
                ], 8, _hoisted_28)
              ], 10, _hoisted_25))
            }), 128))
          ], 512),
          _createElementVNode("p", _hoisted_31, _toDisplayString(selectionAnchor.value !== null ? `已选全局位 ${selectionAnchor.value}，再点另一个端点，可跨整数。` : '点选两个端点或拖选一段，换行处也连续。滚动可查看全部 100 项。'), 1),
          (previewError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(previewError.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_33, [
            _createElementVNode("header", null, [
              _createElementVNode("h3", _hoisted_34, _toDisplayString(editingEntry.value ? '编辑位段说明' : '为选中的位段添加说明'), 1),
              _createElementVNode("button", {
                type: "button",
                disabled: !_unref(ready),
                onClick: newSegment
              }, "新建位段", 8, _hoisted_35)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", null, [
                _cache[20] || (_cache[20] = _createTextVNode("全局起始位", -1)),
                _createElementVNode("input", {
                  value: draft.value.startBit,
                  type: "number",
                  min: "0",
                  max: _unref(SAVE_BIT_COUNT) - 1,
                  step: "1",
                  "aria-label": "起始位",
                  disabled: !_unref(ready) || (!!editingEntry.value && !editingEntry.value.editable),
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (updatePosition('startBit', $event))),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (updatePosition('startBit', $event, true)))
                }, null, 40, _hoisted_37)
              ]),
              _createElementVNode("label", null, [
                _cache[21] || (_cache[21] = _createTextVNode("长度（位）", -1)),
                _createElementVNode("input", {
                  value: draft.value.length,
                  type: "number",
                  min: "1",
                  max: _unref(SAVE_BIT_COUNT),
                  step: "1",
                  "aria-label": "位段长度",
                  disabled: !_unref(ready) || (!!editingEntry.value && !editingEntry.value.editable),
                  onInput: _cache[8] || (_cache[8] = ($event: any) => (updatePosition('length', $event))),
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (updatePosition('length', $event, true)))
                }, null, 40, _hoisted_38)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createTextVNode("全局 " + _toDisplayString(draft.value.startBit) + "–" + _toDisplayString(endBit(draft.value)), 1),
                (validLocation(draft.value))
                  ? (_openBlock(), _createElementBlock("small", _hoisted_40, "跨 " + _toDisplayString(Math.floor(endBit(draft.value) / 32) - Math.floor(draft.value.startBit / 32) + 1) + " 个整数", 1))
                  : (_openBlock(), _createElementBlock("small", _hoisted_41, "范围需在 0–3199 内"))
              ])
            ]),
            _createElementVNode("p", _hoisted_42, _toDisplayString(entryLocation(draft.value)) + "（起始位为该段最低位，向右位权递增）", 1),
            _createElementVNode("div", _hoisted_43, [
              _cache[22] || (_cache[22] = _createElementVNode("span", null, "选中位段（低位 → 高位）", -1)),
              _createElementVNode("code", _hoisted_44, _toDisplayString(draftBinary.value || '—'), 1),
              _createElementVNode("span", _hoisted_45, "= " + _toDisplayString(draftValue.value ?? '—'), 1)
            ]),
            _createElementVNode("label", _hoisted_46, [
              _cache[23] || (_cache[23] = _createTextVNode("说明字符串", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((draft.value.name) = $event)),
                type: "text",
                "aria-label": "位段说明",
                disabled: !_unref(ready) || (!!editingEntry.value && !editingEntry.value.editable),
                placeholder: "例如：跨整数保存的任务进度",
                onInput: _cache[11] || (_cache[11] = ($event: any) => (draftTouched.value = true))
              }, null, 40, _hoisted_47), [
                [_vModelText, draft.value.name]
              ])
            ]),
            _createElementVNode("details", _hoisted_48, [
              _createElementVNode("summary", {
                title: draftRange.value ? `${draftRange.value.min}–${draftRange.value.max}` : ''
              }, "数值范围" + _toDisplayString(draftRange.value ? ` · 可存 ${compactNumber(draftRange.value.min)}–${compactNumber(draftRange.value.max)}` : ''), 9, _hoisted_49),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("label", null, [
                  _cache[24] || (_cache[24] = _createTextVNode("最小值", -1)),
                  _createElementVNode("input", {
                    value: draft.value.min,
                    type: "text",
                    inputmode: draft.value.length === 32 ? 'text' : 'numeric',
                    "aria-label": "位段最小值",
                    disabled: !_unref(ready) || (!!editingEntry.value && !editingEntry.value.editable),
                    onInput: _cache[12] || (_cache[12] = ($event: any) => (updateRange('min', $event))),
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (updateRange('min', $event, true)))
                  }, null, 40, _hoisted_51)
                ]),
                _createElementVNode("label", null, [
                  _cache[25] || (_cache[25] = _createTextVNode("最大值", -1)),
                  _createElementVNode("input", {
                    value: draft.value.max,
                    type: "text",
                    inputmode: draft.value.length === 32 ? 'text' : 'numeric',
                    "aria-label": "位段最大值",
                    disabled: !_unref(ready) || (!!editingEntry.value && !editingEntry.value.editable),
                    onInput: _cache[14] || (_cache[14] = ($event: any) => (updateRange('max', $event))),
                    onChange: _cache[15] || (_cache[15] = ($event: any) => (updateRange('max', $event, true)))
                  }, null, 40, _hoisted_52)
                ])
              ])
            ]),
            (draftIssues.value.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_53, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draftIssues.value, (issue) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: issue.message
                    }, _toDisplayString(issue.message), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("footer", null, [
              _createElementVNode("button", {
                type: "button",
                class: "primary",
                disabled: !canSave.value,
                onClick: saveSegment
              }, "保存位段", 8, _hoisted_54)
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_55, [
          _createElementVNode("header", null, [
            _cache[26] || (_cache[26] = _createElementVNode("h3", { id: "saved-spans-title" }, "已保存的位段说明", -1)),
            _createElementVNode("span", _hoisted_56, _toDisplayString(entries.value.length) + " 段 · 共用整条二进制串", 1)
          ]),
          (!entries.value.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_57, "选择起始位和长度，为这一段填写说明字符串。"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entries.value.filter(item => validLocation(item.field)), (entry) => {
            return (_openBlock(), _createElementBlock("div", {
              key: entry.key,
              class: _normalizeClass(["saved-span", { active: editingKey.value === entry.key }]),
              "data-field-id": entry.field.id
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "saved-span-content",
                "aria-label": `查看位段 ${entry.field.name || '未命名位段'}`,
                onClick: ($event: any) => (selectEntry(entry.key))
              }, [
                _createElementVNode("strong", null, _toDisplayString(entry.field.name || '未命名位段'), 1),
                _createElementVNode("span", _hoisted_60, "全局 " + _toDisplayString(entry.field.startBit) + "–" + _toDisplayString(endBit(entry.field)) + " · " + _toDisplayString(entry.field.length) + " 位 · " + _toDisplayString(entryLocation(entry.field)), 1),
                _createElementVNode("span", _hoisted_61, [
                  _createElementVNode("code", null, _toDisplayString(entryBinary(entry.field)), 1),
                  _createElementVNode("span", null, "= " + _toDisplayString(entryValue(entry.field) ?? '—'), 1)
                ])
              ], 8, _hoisted_59),
              (entry.editable)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "delete",
                    disabled: !_unref(ready),
                    "aria-label": `删除位段 ${entry.field.name || '未命名位段'}`,
                    onClick: ($event: any) => (deleteSegment(entry.key))
                  }, "删除", 8, _hoisted_62))
                : _createCommentVNode("", true),
              (outOfRange(entry.field))
                ? (_openBlock(), _createElementBlock("p", _hoisted_63, "值 " + _toDisplayString(entryValue(entry.field)) + " 超出范围 " + _toDisplayString(entry.field.min) + "–" + _toDisplayString(entry.field.max), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entryIssues(entry.module, entry.field), (issue) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: issue.message,
                  class: "error"
                }, _toDisplayString(issue.message), 1))
              }), 128))
            ], 10, _hoisted_58))
          }), 128))
        ]),
        (orphanEntries.value.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_64, [
              _cache[27] || (_cache[27] = _createElementVNode("p", {
                class: "error",
                role: "alert"
              }, "这些旧位段的范围无效，可以从当前整数开始修正，或删除。", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orphanEntries.value, (entry) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: entry.key,
                  class: "saved-span",
                  "data-field-id": entry.field.id
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(entry.field.name || '未命名位段'), 1),
                    _createElementVNode("p", _hoisted_66, "起始位 " + _toDisplayString(entry.field.startBit) + " · 长度 " + _toDisplayString(entry.field.length), 1),
                    (entry.field.legacyLocation)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_67, "旧定义：整数 " + _toDisplayString(entry.field.legacyLocation.integerIndex) + "，bit " + _toDisplayString(entry.field.legacyLocation.startBit) + "–" + _toDisplayString(entry.field.legacyLocation.endBit), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      disabled: !_unref(ready) || !entry.editable,
                      "aria-label": `修正位段 ${entry.field.name || '未命名位段'}`,
                      onClick: ($event: any) => (repairSegment(entry.key))
                    }, "从整数 [" + _toDisplayString(previewIndex.value) + "] 开始修正", 9, _hoisted_68)
                  ]),
                  (entry.editable)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "delete",
                        disabled: !_unref(ready),
                        "aria-label": `删除位段 ${entry.field.name || '未命名位段'}`,
                        onClick: ($event: any) => (deleteSegment(entry.key))
                      }, "删除", 8, _hoisted_69))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_65))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})